// ********************************
// ********* PURPOSE **************
// --- we use this separate theme for Receipt just because to use differnet font family and font size.
// ------ tech debt, we need to fully utlize this for receipt so that get rid of inline styles ----
// ********************************
// ********************************

import { createTheme, ThemeOptions } from "@mui/material/styles"
import themeComponents from "./theme-components"

const colors = {
  primaryMain: "#000",
  primaryContrastText: "#ffffff",
  secondaryMain: "#E2E8F0",
  secondaryContrastText: "#000",
  errorMain: "#D26969",
  successMain: "#55A37C",
  textPrimary: "#000",
  textSecondary: "#B3B3B3",
  textDisabled: "#9CA3AF",
  divider: "#CBD5E1",
  backgroundDefault: "#ffffff",
  actionHover: "#E2E8F0",
  actionSelected: "#F1F5F9",
  sidebarMain: "#334155",
  sidebarContrastText: "#334155",
  tableFontSize: "0.875rem"
}

const receiptTheme: ThemeOptions = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: colors.primaryMain,
      contrastText: colors.primaryContrastText
    },
    secondary: {
      main: colors.secondaryMain,
      contrastText: colors.secondaryContrastText
    },
    error: {
      main: colors.errorMain
    },
    success: {
      main: colors.successMain
    },
    background: {
      default: colors.backgroundDefault,
      paper: colors.backgroundDefault
    },
    text: {
      primary: colors.textPrimary,
      secondary: colors.textSecondary,
      disabled: colors.textDisabled
    },
    divider: colors.divider,
    action: {
      hover: colors.actionHover,
      selected: colors.actionSelected
    },
    neutral: {
      light: colors.backgroundDefault,
      dark: colors.secondaryContrastText,
      main: colors.secondaryMain,
      contrastText: colors.primaryContrastText
    },
    grey: {
      500: colors.secondaryContrastText
    },
    sidebar: {
      main: colors.sidebarMain,
      contrastText: colors.sidebarContrastText,
      hover: colors.actionSelected,
      submenuBackground: colors.secondaryMain,
      active: colors.actionSelected
    },
    table: {
      headerColor: colors.secondaryContrastText,
      headerBackground: colors.secondaryMain,
      color: colors.primaryMain,
      background: colors.secondaryMain,
      active: colors.actionSelected,
      border: colors.divider,
      fontSize: colors.tableFontSize
    },
    scrollbar: {
      thumb: colors.secondaryContrastText,
      track: colors.secondaryMain
    }
  },
  typography: {
    fontFamily: `'Nunito',"Lato", "Inter",Roboto, sans-serif`,
    h1: { fontSize: "2.1rem", fontWeight: 700, lineHeight: 1.5 },
    h2: { fontSize: "1.8rem", fontWeight: 600, lineHeight: 1.4 },
    h3: { fontSize: "1.5rem", fontWeight: 600, lineHeight: 1.3 },
    h4: { fontSize: "1.38rem", fontWeight: 600, lineHeight: 1.3 },
    h5: { fontSize: "1.2rem", fontWeight: 600, lineHeight: 1.3 },
    body1: { fontSize: "1.2rem", fontWeight: 500, lineHeight: 1.5 },
    body2: { fontSize: "1.05rem", fontWeight: 500, lineHeight: 1.4 },
    subtitle1: { fontSize: "0.9rem", fontWeight: 500, lineHeight: 1.3 },
    subtitle2: { fontSize: "0.75rem", fontWeight: 500, lineHeight: 1.2 },
    caption: { fontSize: "0rem", fontWeight: 500, lineHeight: 1.1 }
  },
  components: themeComponents
})

export default receiptTheme
